<template>
  <select
    name="state"
    v-on:change="onChanged"
    v-model="valueInternal"
    class="browser-default e4s-input-field e4s-input-field--primary"
    :class="errorMessage.length > 0 ? 'e4s-input-field--error' : ''"
  >
    <option v-for="obj in dataArray" :value="obj" :key="getKey(obj)">
      <slot :obj="obj">
        <span v-text="getDisplay(obj)"></span>
      </slot>
    </option>
  </select>
</template>

<script setup lang="ts">
import { type PropType, ref, watch } from 'vue'

interface MyObject {
  [key: string]: unknown
}

export type SelectValue = MyObject | string

const props = defineProps({
  placeHolder: {
    type: String,
    default: () => {
      return ''
    }
  },
  value: {
    type: [Object, String] as PropType<SelectValue>,
    default: () => {
      return ''
    }
  },
  dataArray: {
    type: Array as PropType<SelectValue[]>,
    required: true
  },
  keyProp: {
    type: String,
    default: ''
  },
  displayProp: {
    type: String,
    default: ''
  },
  errorMessage: {
    type: String,
    default: ''
  }
})

//  define emits.
const emit = defineEmits<{
  (e: 'input', value: SelectValue): void
}>()

const valueInternal = ref<MyObject | string>(props.value)

watch(
  () => props.value,
  (newValue) => {
    valueInternal.value = newValue
  },
  {
    immediate: true
  }
)

function onChanged() {
  emit('input', valueInternal.value)
}

function getKey(obj: SelectValue): string {
  if (props.keyProp.length === 0) {
    return (obj as any).toString()
  }
  const objKey = (obj as MyObject)[props.keyProp]
  return (objKey as any).toString()
}

function getDisplay(obj: SelectValue): string {
  if (props.displayProp.length === 0) {
    return (obj as any).toString()
  }
  const objDisplay = ((obj as MyObject)[props.displayProp] as any).toString()
  return objDisplay as string
}

/**
 * Exmaple usage
 *
 <FieldSelect :data-array="['one', 'tow', 'thre']" />

 <FieldSelect
    key-prop="id"
    display-prop="val"
    :value="{ id: 2, val: 'two' }"
    :data-array="[
      { id: 1, val: 'one' },
      { id: 2, val: 'two' },
      { id: 3, val: 'three' }
    ]"
 />
 *
 *
 <FieldSelect :data-array="clubCompCategories" v-model="clubCompDefinitionInternal.category">
  <template slot-scope="{obj}">
    {{obj.categoryName}}
  </template>
 </FieldSelect>
 *
 */
</script>
